import styles from "./textBankContent.module.scss";
import clsx from "clsx";

const TextBankContent = ({ data, dashedArray }) => {
  return (
    <div className={styles.textGrid}>
      {data.map((it, idx) => {
        const dashed = dashedArray === undefined ? false : dashedArray[idx];
        return (
          <span
            key={idx}
            className={clsx(
              styles.textWord,
              dashed && styles.dashed
            )}
          >
            {it.content}
          </span>
        );
      })}
    </div>
  );
};

export default TextBankContent;
